module.exports = __webpack_public_path__ + "static/media/issue_with_attachment_marker.9f7b12f9.svg";